export var shippingUpdateFailure = function shippingUpdateFailure(t) {
  return {
    severity: 'error',
    message: t('The shipping address could not be saved to your profile at this time'),
    duration: 'long'
  };
};